import React from 'react'
import {LocalReducerEventProps, LocalReducerState, ReviewFilmType} from "./reducer.types";
import {FilmType} from "../../../models/film";
import {pendingFilmId} from "./reducer.constants";

const SET_PENDING_FILM = 'SET_PENDING_FILM';
const SET_DB_FILMS = 'SET_DB_FILMS';
const SET_FILM_TO_DELETE = 'SET_FILM_TO_DELETE';
const SET_FILM_FOLDER = 'SET_FILM_FOLDER';
const CLEAR = 'CLEAR';
const SET_DUPLICATES = 'SET_DUPLICATES';
const SET_FIRST_FOLDER = 'SET_FIRST_FOLDER';

export const dispatchToProps = (dispatch: React.Dispatch<any>): LocalReducerEventProps => ({
    setPendingFilm: film => {
        dispatch({
            type: SET_PENDING_FILM,
            film,
        })
    },
    setDBFilms: films => {
        dispatch({
            type: SET_DB_FILMS,
            films,
        })
    },
    setFilmToDelete: (id, toDelete) => {
        dispatch({
            type: SET_FILM_TO_DELETE,
            id,
            toDelete,
        })
    },
    setFilmFolder: (id, folder) => {
        dispatch({
            type: SET_FILM_FOLDER,
            id,
            folder
        })
    },
    clearFilms: () => {
        dispatch({
            type: CLEAR,
        })
    },
    setDuplicates: (list) => {
        dispatch({
            type: SET_DUPLICATES,
            list
        })
    },
    setFirstFolder: (folder) => {
        dispatch({
            type: SET_FIRST_FOLDER,
            folder
        })
    }
});

export const initState: LocalReducerState = {
    films: {},
    duplicates: []
};

export const component_reducer = (state: LocalReducerState = initState, action: any): LocalReducerState => {
    switch (action.type) {
        case SET_PENDING_FILM: {
            const newFilm: ReviewFilmType = {
                id: pendingFilmId,
                file_name: action.film.filename,
                folder: action.film.folder,
                format: action.film.extension,
                size: action.film.size_mb,
                checksum: action.film.md5,
                imdb_id: action.film.imdbId?.id || '',
                filmaffinity_id: action.film.filmaffinityId?.id || '',
                languages: action.film.langs && action.film.langs?.length > 0 ? action.film.langs?.split(',') : undefined,
                subtitles: action.film.subs && action.film.subs?.length > 0 ? action.film.subs?.split(',') : undefined,
                pending_data: action.film,
                toDelete: false,
            }
            return {
                ...state, films: {...state.films, [pendingFilmId]: newFilm}
            }
        }
        case SET_DB_FILMS: {
            const newFilms: {[key: number]: ReviewFilmType} = action.films.reduce((acc: typeof state.films, film: FilmType) => {
                return {...acc, [film.id!]: {...film, toDelete: false}}
            }, {})
            return {
                ...state, films: {...newFilms}
            }
        }
        case SET_FILM_TO_DELETE:
            return {...state, films: {...state.films, [action.id]: {...state.films[action.id], toDelete: action.toDelete}}}
        case SET_FILM_FOLDER:
            return {...state, films: {...state.films, [action.id]: {...state.films[action.id], newFolder: action.folder}}}
        case SET_DUPLICATES:
            return {...state, duplicates: action.list}
        case SET_FIRST_FOLDER:
            return {
                ...state, films: {...state.films, [pendingFilmId]: {...state.films[pendingFilmId], newFolder: action.folder}}
            }
        case CLEAR:
            return {...state, films: {}, duplicates: []}
        default:
            return state
    }
};
